(function () {
  'use strict';

  if (window.__lpwConversionTrackingInstalled) return;
  window.__lpwConversionTrackingInstalled = true;

  var GA4_DESTINATION_ID = 'G-1D1PHC0HTB';
  var pendingAcceleratedCheckoutEvents = [];
  var acceleratedCheckoutRetryTimer = null;
  var acceleratedCheckoutRetryCount = 0;

  function textFor(element) {
    return (element.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function trackingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;

    try {
      return typeof privacy.analyticsProcessingAllowed !== 'function'
        || privacy.analyticsProcessingAllowed();
    } catch (error) {
      return false;
    }
  }

  function publish(name, payload) {
    if (!trackingAllowed()) return;

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try { window.Shopify.analytics.publish(name, payload); } catch (error) {}
    }

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
    } catch (error) {}
  }

  function ga4TargetIsConfigured() {
    var layer = window.dataLayer || [];
    return layer.some(function (entry) {
      return entry && entry[0] === 'config' && entry[1] === GA4_DESTINATION_ID;
    });
  }

  function isThemePreview() {
    var shopify = window.Shopify || {};
    var themeRole = shopify.theme && shopify.theme.role;
    return /(?:^|[?&])preview_theme_id=/.test(window.location.search)
      || shopify.designMode === true
      || Boolean(themeRole && themeRole !== 'main' && themeRole !== 'live');
  }

  function allowsGa4Qa() {
    return /(?:^|[?&])_lpw_ga_qa=1(?:&|$)/.test(window.location.search);
  }

  function recordAcceleratedCheckoutForQa(payload) {
    try {
      (window.__lpwAnalyticsQaEvents = window.__lpwAnalyticsQaEvents || []).push(Object.assign({
        event: 'pdp_accelerated_checkout_click'
      }, payload));
    } catch (error) {}
  }

  function flushAcceleratedCheckoutEvents(forceBeforeNavigation) {
    acceleratedCheckoutRetryTimer = null;
    if (!pendingAcceleratedCheckoutEvents.length) return;

    if (typeof window.gtag === 'function' && (ga4TargetIsConfigured() || forceBeforeNavigation === true)) {
      try {
        while (pendingAcceleratedCheckoutEvents.length) {
          window.gtag('event', 'pdp_accelerated_checkout_click', Object.assign(
            {},
            pendingAcceleratedCheckoutEvents[0],
            { send_to: GA4_DESTINATION_ID, transport_type: 'beacon' }
          ));
          pendingAcceleratedCheckoutEvents.shift();
        }
        acceleratedCheckoutRetryCount = 0;
        return;
      } catch (error) {
        // Leave the unsent event queued while the app-owned Google tag finishes initialising.
      }
    }

    acceleratedCheckoutRetryCount += 1;
    if (acceleratedCheckoutRetryCount <= 8) {
      acceleratedCheckoutRetryTimer = window.setTimeout(
        flushAcceleratedCheckoutEvents,
        Math.min(100 * Math.pow(2, acceleratedCheckoutRetryCount - 1), 2000)
      );
    }
  }

  function publishAcceleratedCheckout(payload) {
    if (!trackingAllowed()) return;

    // Preview QA uses a private in-memory buffer so a GTM custom-event trigger cannot leak it to GA4.
    recordAcceleratedCheckoutForQa(payload);
    if (isThemePreview() && !allowsGa4Qa()) return;

    pendingAcceleratedCheckoutEvents.push(payload);
    if (!acceleratedCheckoutRetryTimer) flushAcceleratedCheckoutEvents();
  }

  // A genuinely fast checkout click can beat Shopify's app-owned GA4 config. Give the queued
  // command one final beacon-backed send opportunity before the PDP document is discarded.
  window.addEventListener('pagehide', function () {
    flushAcceleratedCheckoutEvents(true);
  }, { capture: true });

  function eventPath(event) {
    if (typeof event.composedPath === 'function') return event.composedPath();

    var path = [];
    var node = event.target;
    while (node) {
      path.push(node);
      node = node.parentNode || node.host;
    }
    return path;
  }

  function matches(node, selector) {
    return node && node.nodeType === 1 && typeof node.matches === 'function' && node.matches(selector);
  }

  function walletType(button, wrapper) {
    var tagName = String(button.tagName || '').toLowerCase();
    if (tagName.endsWith('-wallet-button')) {
      return tagName.slice(0, -'-wallet-button'.length).replace(/-/g, '_');
    }
    if (matches(button, '.shopify-payment-button__button')) return 'buy_it_now';
    return 'unknown';
  }

  function viewportBucket() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width <= 384) return 'mobile_384_or_less';
    if (width <= 390) return 'mobile_385_390';
    if (width <= 402) return 'mobile_391_402';
    if (width <= 440) return 'mobile_403_440';
    if (width <= 767) return 'mobile_441_767';
    if (width <= 1023) return 'tablet_768_1023';
    if (width <= 1365) return 'desktop_1024_1365';
    if (width <= 1919) return 'desktop_1366_1919';
    return 'desktop_1920_plus';
  }

  function visibleQuantity(form) {
    if (!form) return 1;
    var controls = Array.prototype.slice.call(form.querySelectorAll('[name="quantity"]'));
    var control = controls.find(function (candidate) {
      return !candidate.disabled && candidate.offsetParent !== null;
    }) || controls.find(function (candidate) {
      return !candidate.disabled;
    });
    var quantity = Number(control && control.value);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function experimentContext(wrapper) {
    var productRoot = wrapper.closest('.js-product, .cc-main-product');
    var experiment = productRoot && productRoot.querySelector('[data-pdp-addon-experiment]');
    if (!experiment) return {};

    var experimentId = experiment.dataset.experimentId || '';
    var variant = experiment.dataset.addonExperimentVariant || '';
    var assignmentSource = experiment.dataset.addonExperimentAssignmentSource || '';
    if (!experimentId || !variant || !assignmentSource) return {};

    return {
      experiment_id: experimentId,
      variant: variant,
      assignment_source: assignmentSource
    };
  }

  document.addEventListener('click', function (event) {
    var cta = event.target.closest('[data-track-cta]');
    if (!cta) return;

    var section = cta.closest('[data-track-section]');
    publish('homepage_cta_clicked', {
      cta: cta.getAttribute('data-track-cta') || '',
      section: section ? section.getAttribute('data-track-section') || '' : '',
      href: cta.href || '',
      label: textFor(cta)
    });
  });

  // One section_viewed per section per page load, when it reaches mid-viewport: shows where readers stop scrolling.
  if ('IntersectionObserver' in window) {
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        sectionObserver.unobserve(entry.target);
        publish('section_viewed', { section: entry.target.getAttribute('data-track-section') || '' });
      });
    }, { rootMargin: '0px 0px -50% 0px' });
    document.querySelectorAll('[data-track-section]').forEach(function (el) { sectionObserver.observe(el); });
  }

  document.addEventListener('click', function (event) {
    var path = eventPath(event);
    var wrapper = path.find(function (node) {
      return matches(node, '[data-pdp-accelerated-checkout]');
    });
    if (!wrapper) return;

    // Exclude Shopify's separate "More payment options" link: only the primary wallet/button counts.
    var button = path.find(function (node) {
      return matches(node, '[slot="button"], .shopify-payment-button__button:not(.shopify-payment-button__more-options)');
    });
    if (!button || matches(button, '[disabled], [aria-disabled="true"]')) return;

    var form = wrapper.closest('form');
    var variantInput = form && form.querySelector('input[name="id"]:not([disabled])');
    var formVariantId = String((variantInput && variantInput.value) || '');
    var wrapperVariantId = String(wrapper.dataset.variantId || '');
    var variantId = formVariantId || wrapperVariantId;
    var variantMetadataMatches = !formVariantId || formVariantId === wrapperVariantId;
    var quantity = visibleQuantity(form);
    var price = variantMetadataMatches ? Number(wrapper.dataset.variantPrice || 0) / 100 : 0;
    var productId = String(wrapper.dataset.productId || '');
    var productTitle = String(wrapper.dataset.productTitle || '').slice(0, 100);
    var variantTitle = variantMetadataMatches
      ? String(wrapper.dataset.variantTitle || '').slice(0, 100)
      : '';
    var variantOptions = variantMetadataMatches
      ? String(wrapper.dataset.variantOptions || '').slice(0, 100)
      : '';

    var payload = Object.assign({
      product_id: productId,
      product_handle: String(wrapper.dataset.productHandle || '').slice(0, 100),
      product_title: productTitle,
      variant_id: variantId,
      variant_title: variantTitle,
      variant_options: variantOptions,
      variant_metadata_status: variantMetadataMatches ? 'matched' : 'id_only',
      wallet_type: walletType(button, wrapper),
      checkout_source: 'pdp',
      viewport_bucket: viewportBucket(),
      currency: wrapper.dataset.currency || '',
      quantity: quantity
    }, experimentContext(wrapper));

    if (variantMetadataMatches) {
      payload.value = price * quantity;
      payload.items = [{
        item_id: variantId || productId,
        item_name: productTitle,
        item_variant: variantTitle,
        price: price,
        quantity: quantity
      }];
    }

    publishAcceleratedCheckout(payload);
  }, true);

  document.addEventListener('on:variant:change', function (event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    var product = detail.product;
    if (!variant || !product) return;

    var productRoot = event.target && typeof event.target.closest === 'function'
      ? event.target.closest('.js-product, .cc-main-product')
      : null;
    var acceleratedCheckout = productRoot && productRoot.querySelector('[data-pdp-accelerated-checkout]');
    if (acceleratedCheckout && String(acceleratedCheckout.dataset.productId || '') === String(product.id || '')) {
      acceleratedCheckout.dataset.variantId = String(variant.id || '');
      acceleratedCheckout.dataset.variantTitle = variant.title || '';
      acceleratedCheckout.dataset.variantOptions = Array.isArray(variant.options) ? variant.options.join(' | ') : '';
      acceleratedCheckout.dataset.variantPrice = String(variant.price || 0);
    }

    publish('lpw_variant_selected', {
      product_id: String(product.id || ''),
      product_title: product.title || '',
      variant_id: String(variant.id || ''),
      variant_title: variant.title || '',
      variant_options: Array.isArray(variant.options) ? variant.options.join(' | ') : '',
      value: Number(variant.price || 0) / 100,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''
    });
  });

  document.addEventListener('on:bundle:add', function (event) {
    var detail = event.detail || {};
    publish('lpw_bundle_add_success', {
      currency: detail.currency || '',
      value: Number(detail.value || 0),
      item_count: Array.isArray(detail.items) ? detail.items.length : 0,
      items: detail.items || []
    });
  });

  document.addEventListener('on:bundle:error', function (event) {
    var detail = event.detail || {};
    publish('lpw_bundle_add_error', {
      reason: String(detail.reason || 'unknown').slice(0, 160),
      item_count: Array.isArray(detail.items) ? detail.items.length : 0
    });
  });

  function pageType() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var type = meta && meta.page && meta.page.pageType;
    if (type) return String(type);
    var path = window.location.pathname;
    if (path === '/' || /^\/[a-z]{2}(-[a-z]{2})?\/?$/.test(path)) return 'home';
    var match = path.match(/\/(collections|products|pages|blogs|cart|search)\b/);
    return match ? match[1].replace(/s$/, '') : 'other';
  }

  function sessionValue(key, firstValue) {
    try {
      var stored = window.sessionStorage.getItem(key);
      if (stored !== null) return stored;
      window.sessionStorage.setItem(key, firstValue);
    } catch (error) {}
    return firstValue;
  }

  // Clarity custom tags. The stub queues calls until snippets/clarity.liquid loads Clarity (consent-gated), so nothing is sent without consent.
  var HOMEPAGE_AB_ARMS = { '140980584551': 'control', '167429570663': 'lokko_treatment' };
  var paidNow = /(?:^|[?&])(gclid|gbraid|wbraid)=/.test(window.location.search)
    || /(?:^|[?&])utm_medium=(cpc|ppc|paid)(?:&|$)/i.test(window.location.search);
  if (paidNow) { try { window.sessionStorage.setItem('lpw_paid_visit', 'yes'); } catch (error) {} }
  var clarityTags = {
    paid_visit: paidNow ? 'yes' : sessionValue('lpw_paid_visit', 'no'),
    landing_page_type: sessionValue('lpw_landing_type', pageType()),
    page_type: pageType(),
    viewport_bucket: viewportBucket()
  };
  var themeId = String((window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '');
  if (HOMEPAGE_AB_ARMS[themeId]) clarityTags.hp_ab_arm = HOMEPAGE_AB_ARMS[themeId];
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  Object.keys(clarityTags).forEach(function (key) {
    try { window.clarity('set', key, clarityTags[key]); } catch (error) {}
  });
  window.__lpwClarityTags = clarityTags;

  // Collection pages: grid reach, section views, card taps (select_item with position) and finder-panel clicks.
  var collectionMatch = window.location.pathname.match(/\/collections\/([^/?#]+)\/?$/);
  if (collectionMatch && pageType() === 'collection') {
    var listId = decodeURIComponent(collectionMatch[1]);
    var listName = (document.querySelector('h1') ? textFor(document.querySelector('h1')) : listId).slice(0, 100);
    var loadedAt = Date.now();
    var sectionName = function (el) {
      return 'collection:' + String(el.id || '').replace(/^shopify-section-(template--\d+__)?/, '');
    };
    var productCards = function () {
      return Array.prototype.slice.call(document.querySelectorAll('.main-products-grid li.js-pagination-result'))
        .filter(function (li) { return li.querySelector('.card--product'); });
    };

    if ('IntersectionObserver' in window) {
      var collectionSectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          collectionSectionObserver.unobserve(entry.target);
          publish('section_viewed', { section: sectionName(entry.target), page_type: 'collection', item_list_id: listId });
        });
      }, { rootMargin: '0px 0px -50% 0px' });
      document.querySelectorAll('main .shopify-section').forEach(function (el) {
        if (!el.querySelector('[data-track-section]')) collectionSectionObserver.observe(el);
      });

      var firstCard = productCards()[0];
      if (firstCard) {
        var gridObserver = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          gridObserver.disconnect();
          publish('collection_grid_reached', {
            item_list_id: listId,
            viewport_bucket: viewportBucket(),
            seconds_since_load: Math.round((Date.now() - loadedAt) / 1000),
            paid_visit: clarityTags.paid_visit
          });
        }, { threshold: 0.5 });
        gridObserver.observe(firstCard);
      }
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var li = link.closest('.main-products-grid li.js-pagination-result');
      if (li && link.closest('.card--product')) {
        var card = li.querySelector('.card--product');
        var cardIndex = productCards().indexOf(li);
        var handleMatch = link.pathname.match(/\/products\/([^/?#]+)/);
        var handle = handleMatch ? decodeURIComponent(handleMatch[1]) : '';
        var idEl = li.querySelector('[data-product-id]');
        publish('select_item', {
          item_list_id: listId,
          item_list_name: listName,
          index: cardIndex,
          viewport_bucket: viewportBucket(),
          items: [{
            item_id: idEl ? String(idEl.getAttribute('data-product-id')) : handle,
            item_name: (link.getAttribute('aria-label') || textFor(link)).slice(0, 100),
            item_handle: handle,
            index: cardIndex,
            item_list_id: listId,
            item_list_name: listName,
            sold_out: card.classList.contains('card--sold-out')
          }]
        });
        return;
      }
      var section = link.closest('.shopify-section');
      if (section && /__(quick_picks_summary|quick_filters)$/.test(section.id)) {
        var siblings = Array.prototype.slice.call(section.querySelectorAll('a[href]'));
        publish('collection_finder_click', {
          section: sectionName(section),
          item_list_id: listId,
          position: siblings.indexOf(link),
          label: textFor(link),
          href: link.getAttribute('href') || '',
          viewport_bucket: viewportBucket()
        });
      }
    });
  }
})();
